/** @format */
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'HomeProjectGroup';

const classes = {
  header: `${PREFIX}-header`,
  groupName: `${PREFIX}-groupName`,
  groupProjectsCount: `${PREFIX}-groupProjectsCount`,
  tableContainer: `${PREFIX}-tableContainer`,
  tableBody: `${PREFIX}-tableBody`,
  tableHeadRow: `${PREFIX}-tableHeadRow`,
  paper: `${PREFIX}-paper`,
};

const Root = styled(Box)(({theme}) => ({
  [`& .${classes.header}`]: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(4),
  },
  [`& .${classes.groupName}`]: {
    color: theme.palette.figma_gray_light_1?.main,
    fontSize: '32px',
    fontWeight: '300',
    lineHeight: '40px',
  },
  [`& .${classes.groupProjectsCount}`]: {
    color: theme.palette.figma_gray_middle_dark?.main,
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.paper}`]: {
    marginTop: theme.spacing(2),
    overflowX: 'auto',
    background: 'none',
  },
  [`& .${classes.tableContainer}`]: {
    border: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      minWidth: '740px',
    },
  },
  [`& .${classes.tableBody}`]: {
    '> .MuiTableRow-root:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
    },
  },
  [`& .${classes.tableHeadRow}`]: {
    height: '56px',
    background: theme.palette.figma_gray_dark_1?.main,
    '> .MuiTableCell-root:not(:last-of-type)': {
      borderRight: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
    },
    '> .MuiTableCell-root:nth-of-type(2)': {
      width: '40px',
    },
    '> .MuiTableCell-root:nth-of-type(3)': {
      width: '90px',
    },
    '> .MuiTableCell-root:nth-of-type(4)': {
      width: '200px',
    },
    [theme.breakpoints.down('md')]: {
      '> .MuiTableCell-root:nth-of-type(4)': {
        width: '56px',
      },
    },
  },
}));

export {classes as groupClasses, Root as GroupRoot};
